import type { campanhas as pt } from '../pt-BR/campanhas';
import type { Traducao } from '../Traducao';

export const campanhas = {
  titulo: 'Campañas',
  nova: 'Nueva campaña',
  colunas: {
    nome: 'Nombre',
    periodo: 'Período',
    fase: 'Fase',
    progresso: 'Progreso',
    acoes: 'Acciones',
  },
  /** Selo da campanha ativa na lista (spec 29 R14). */
  ativaSelo: 'Activa',
  estados: {
    aberta: 'Abierta',
    agendada: 'Programada',
    encerrada: 'Cerrada',
    inativa: 'Inactiva',
  },
  form: {
    nome: 'Nombre',
    inicio: 'Inicio',
    fim: 'Fin',
    janela: 'Ventana prevista de envío',
    entregaPrevista: 'Estimación de recepción del obsequio',
    entregaPrevistaHint:
      'Indique una estimación de las fechas entre las que el profesional recibirá el obsequio. Se muestra a la persona en el formulario.',
    entregaInicio: 'De',
    entregaFim: 'Hasta',
    dataInvalida: 'Fecha no válida.',
    calendario: 'Elegir {{campo}} en el calendario',
  },
  acoes: {
    abrir: 'Abrir',
    ver: 'Ver',
    editar: 'Editar',
    carregarAxiis: 'Cargar desde Axiis',
    carregarDeNovo: 'Cargar de nuevo',
    revisarTexto: 'Revisar mensaje',
    editarTexto: 'Mensaje de invitación',
    abrirCampanha: 'Abrir campaña',
    desativarEAbrir: 'Desactivar {{outra}} y abrir esta',
    enviarConvites: 'Enviar invitaciones',
    enviarNaoRecebidos_one: 'Enviar a 1 persona que no recibió',
    enviarNaoRecebidos_other: 'Enviar a los {{count}} que no recibieron',
    lembrar_one: 'Recordar a quien no respondió',
    lembrar_other: 'Recordar a los {{count}} que no respondieron',
    baixarPlanilha: 'Descargar planilla de envío',
    pausar: 'Pausar',
    reabrir: 'Reabrir',
    fechar: 'Cerrar campaña',
    editarDatas: 'Editar fechas',
  },
  confirmar: {
    desativar: '¿Pausar {{nome}}? El formulario deja de aceptar respuestas. No se borra nada.',
    fechar: '¿Cerrar {{nome}}? La campaña sale del aire y permite abrir otra.',
  },
  checklist: {
    rotulo: 'Preparación de la campaña',
    concluido: 'Listo',
    pendente: 'Pendiente',
    participantes: 'Destinatarios',
    ninguem: 'Nadie en la campaña todavía',
    texto: 'Mensaje de invitación',
    naoRevisado: 'Todavía no revisado',
    editarTexto: 'Editar mensaje',
    periodo: 'Período',
    terminou: 'El período terminó',
    abrirTitulo: 'Abrir la campaña',
    falta: 'Para abrir, falta: {{itens}}.',
    faltaParticipantes: 'cargar los destinatarios',
    faltaTexto: 'revisar el mensaje de invitación',
    faltaPeriodo: 'corregir el período',
  },
  acompanhamento: 'Seguimiento',
  participantes: 'Destinatarios',
  convite: { titulo: 'Mensaje de invitación', concluirRevisao: 'Terminar revisión' },
  descricao: 'Del {{inicio}} al {{fim}}',
  descricaoComEntrega: 'Del {{inicio}} al {{fim}} · recepción del obsequio: {{entrega}}',
  fases: {
    preparacao: 'En preparación',
    vencida: 'Vencida',
    agendada: 'Programada',
    aberta: 'Abierta',
    encerrada: 'Finalizada',
    pausada: 'En pausa',
    fechada: 'Cerrada',
  },
  resumoAbrir_one: '{{count}} persona · {{idiomas}} · del {{inicio}} al {{fim}}',
  resumoAbrir_other: '{{count}} personas · {{idiomas}} · del {{inicio}} al {{fim}}',
  abrir: {
    pessoas_one: '{{count}} persona · {{idiomas}}',
    pessoas_other: '{{count}} personas · {{idiomas}}',
    personalizado: 'personalizado',
    padrao: 'predeterminado',
    oQueAcontece:
      'Al abrir, el enlace empieza a aceptar respuestas. Ningún e-mail sale solo: las invitaciones las envía en Seguimiento.',
    oQueAconteceAgendada:
      'Al abrir, el enlace acepta respuestas a partir del {{inicio}}. Ningún e-mail sale solo: las invitaciones las envía en Seguimiento.',
  },
  vazio: 'Ninguna campaña creada.',
  dialogo: { abrir: 'Abrir {{nome}}', outraAtiva: 'Ahora está abierta: {{outra}}.' },
  funil: {
    naCampanha: 'En la campaña',
    convidados: 'Invitados',
    acessaram: 'Accedieron',
    responderam: 'Respondieron',
    naoConvidados_one: '{{count}} sin invitar',
    naoConvidados_other: '{{count}} sin invitar',
    falhas: '{{count}} con error',
    naoAcessaram_one: '{{count}} no accedió',
    naoAcessaram_other: '{{count}} no accedieron',
    pararamNoMeio_one: '{{count}} accedió y no respondió',
    pararamNoMeio_other: '{{count}} accedieron y no respondieron',
    doTotal: '{{p}}% del total',
  },
  filtros: {
    busca: 'Buscar por nombre',
    todasFases: 'Todas las fases',
    periodo: 'Período',
    limpar: 'Limpiar todo',
  },
  semResultado: 'Ninguna campaña con estos filtros.',
} as const satisfies Traducao<typeof pt>;
